"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _index = require("../../Input/index");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var EmptyObjectAtom = function EmptyObjectAtom() {
  return _react2.default.createElement("div", {
    className: "flex-auto mh3 pb3"
  }, _react2.default.createElement(_index2.default, {
    disabled: true
  }));
};

var ObjectAtom = function ObjectAtom(_ref) {
  var disabled = _ref.disabled,
      error = _ref.error,
      object = _ref.object,
      onChange = _ref.onChange,
      renderObject = _ref.renderObject;

  if (disabled) {
    return _react2.default.createElement(EmptyObjectAtom, null);
  }

  return _react2.default.createElement("div", {
    className: "flex-auto mh3 pb3"
  }, renderObject({
    error: error,
    onChange: onChange,
    value: object
  }));
};

exports.default = ObjectAtom;